// extracted by mini-css-extract-plugin
export default {"active":"Navigation_active__sf0Es","open":"Navigation_open__8F+IH","dark":"Navigation_dark__yMX4W"};